import { ref } from 'vue';

export const useHover = (defaultValue: boolean = false) => {
  const isHover = ref<boolean>(defaultValue);

  const setHoverActive = (): void => {
    isHover.value = true;
  };

  const setHoverInactive = (): void => {
    isHover.value = false;
  };

  return {
    isHover,
    setHoverActive,
    setHoverInactive,
  };
};
